import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { Modal, Select } from "antd";
import React from "react";

// Claude: extracted from Seller.tsx 23-03-2026
interface Props {
  isOpen: boolean;
  onClose: () => void;
  industryNodes: any[];
  assignIndustryIds: string[];
  setAssignIndustryIds: (ids: string[]) => void;
  selectedRowCount: number;
  onAssign: () => void;
  loading: boolean;
}

const SellerAssignIndustryModal = ({
  isOpen, onClose, industryNodes, assignIndustryIds, setAssignIndustryIds,
  selectedRowCount, onAssign, loading,
}: Props) => (
  <Modal
    title="Assign Industry"
    footer={null}
    open={isOpen}
    onCancel={onClose}
    onOk={onClose}
  >
    <Box p={2}>
      <Text mb={3} fontSize="sm">
        Select one or more industries to assign to {selectedRowCount} seller{selectedRowCount !== 1 ? "s" : ""}.
      </Text>
      <Select
        mode="multiple"
        showSearch
        optionFilterProp="label"
        placeholder="Select Industries"
        style={{ width: "100%" }}
        value={assignIndustryIds}
        onChange={(values) => setAssignIndustryIds(values)}
        options={industryNodes
          .filter((n: any) => !n.parentId)
          .map((n: any) => ({ label: n.name, value: n._id }))}
      />
      <Flex justifyContent="end" mt={4}>
        <Button background="#0E122F" color="white" px={4} _hover={{ background: "#2E7D32" }}
          onClick={onAssign} isLoading={loading}
        >
          Assign
        </Button>
      </Flex>
    </Box>
  </Modal>
);

export default SellerAssignIndustryModal;
